import React, { useEffect } from "react";

const MuteAudioButton = ({ audio, muteAudio }) => {
  if (!audio) {
    return (
      <button onClick={muteAudio} className="callBtn">
        <div>
          <span className="fa-stack fa-lg videoBtn">
            <i
              className="fa fa-microphone-slash"
              aria-hidden="true"
              style={{ color: "red" }}
            />
          </span>
        </div>
      </button>
    );
  } else {
    return (
      <button onClick={muteAudio} className="callBtn">
        <div>
          <span className="fa-stack fa-lg videoBtn">
            <i className="fa fa-microphone" aria-hidden="true" />
          </span>
        </div>
      </button>
    );
  }
};

const CallButton = ({ endSession, roomClosed }) => {
  if (localStorage.getItem("user_type") === "doctor") {
    return (
      <button
        onClick={() => {
          endSession(roomClosed);
        }}
        className="callBtn endCall"
      >
        <div>
          <span className="fa-stack fa-lg videoBtn">
            <i className="fa fa-phone fa-rotate-45"></i>
          </span>
        </div>
      </button>
    );
  } else {
    return <span></span>;
  }
};

const ScreenShareButton = ({ isScreenSharing, screenShare }) => {
  var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  if (localStorage.getItem("user_type") === "doctor" && !isMobile) {
    if (!isScreenSharing) {
      return (
        <button onClick={screenShare} className="callBtn">
          <div>
            <span className="fa-stack fa-lg videoBtn">
              <i className="fa fa-laptop fa-stack-3x"></i>
              <i className="fa fa-ban fa-stack-1x text-danger"></i>
            </span>
          </div>
        </button>
      );
    } else {
      return (
        <button onClick={screenShare} className="callBtn">
          <div>
            <span className="fa-stack fa-lg videoBtn">
              <i className="fa fa-laptop fa-stack-1x"></i>
            </span>
          </div>
        </button>
      );
    }
  } else {
    return <span></span>;
  }
};

const MuteVideoButton = ({ video, muteVideo }) => {
  if (!video) {
    return (
      <button onClick={muteVideo} className="callBtn">
        <div>
          <span className="fa-stack fa-lg videoBtn">
            <i className="fa fa-video-camera fa-stack-3x"></i>
            <i className="fa fa-ban fa-stack-1x text-danger"></i>
          </span>
        </div>
      </button>
    );
  } else {
    return (
      <button onClick={muteVideo} className="callBtn">
        <div>
          <span className="fa-stack fa-lg videoBtn">
            <i className="fa fa-video-camera fa-stack-1x"></i>
          </span>
        </div>
      </button>
    );
  }
};

const OnHoldButton = ({ handleOnHold }) => {
  if (localStorage.getItem("user_type") === "doctor") {
    return (
      <button onClick={handleOnHold} className="onHoldBtn">
        <div>
          <span className="fa-stack fa-sm">
            <p className="m-0">Hold</p>
          </span>
        </div>
      </button>
    );
  } else {
    return <span></span>;
  }
};

const Toolbar = ({
  muteAudio,
  muteVideo,
  screenShare,
  endSession,
  handleOnHold,
  ...props
}) => {
  useEffect(() => {
    if (
      props.isAudioCall === true &&
      props.isVideoCall === false &&
      props.videoStatus
    ) {
      muteVideo();
    }
  }, []);

  return (
    <div className={"twilio-toolbar "}>
      <MuteAudioButton audio={props.audioStatus} muteAudio={muteAudio} />
      <CallButton
        endSession={endSession}
        roomClosed={props.roomClosed}
        roomInfo={props.room}
      />
      <MuteVideoButton video={props.videoStatus} muteVideo={muteVideo} />
      <ScreenShareButton
        isScreenSharing={props.isScreenSharing}
        screenShare={screenShare}
      />

      {/* Button to put call on hold */}
      <OnHoldButton handleOnHold={handleOnHold} />
    </div>
  );
};

export default Toolbar;
